import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery';

const AboutMe = (props) => {
    const mediaMatch = useMediaQuery('(min-width:1200px)');
    const mobile = useMediaQuery('(max-width:500px)');
    return (
        <div style={{display:mediaMatch?"flex":"block", gap:'10px', padding:'5%',marginTop:mediaMatch?"0":"5%"}}>
            <div style={{
                width:'65vw',
                fontSize:28
            }}>
                <p>Full-stack web developer with experience in React.js, MongoDB and Node.js. Designed templates for frontend interfaces like digital forms.</p>
                <p>I enjoy exploring new tech and the solutions that they offer. I am passionate about Web development and solving problems. Also I am good at visualization
                and analytics in python.</p> <p> I spend my free time reading articles and blogs. </p>
                
            </div>
            <div style={{
                width:'35vw'
            }}>
                <img src='./web_developing.gif' width={mediaMatch?'480px':mobile? "220px":'420px'} alt="Web development illustration" style={{paddingTop:'35px'}}/>
            </div>
        </div>
    )
}

export default AboutMe;